/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import useEnterpriseMegaMenuLinks, {
  useEnterpriseOrgScopedMenuLinks,
} from 'bundles/composable-page-header-enterprise/hooks/useEnterpriseMegaMenuLinks';
import SimplifiedMegaMenuWrapper from 'bundles/megamenu/components/SimplifiedMegaMenuWrapper';
import MegaMenuLinksProvider from 'bundles/megamenu/providers/MegaMenuLinksProvider';
import { useOrgSlug } from 'bundles/unified-common/contexts/org-scoped/ThirdPartyOrganizationContext';
import { useIsOrgScopedHome } from 'bundles/unified-common/hooks/useIsOrgScopedHome';

const styles = {
  exploreButtonHeaderSpacing: css`
    margin-left: var(--cds-spacing-100);
    margin-right: calc(var(--cds-spacing-50) * -1);
  `,
};

const ExploreMegaMenuGridItem = () => {
  const isOrgScopedHome = useIsOrgScopedHome();
  const orgScopedLinks = useEnterpriseOrgScopedMenuLinks();
  const megaMenuLinks = useEnterpriseMegaMenuLinks();
  const orgSlug = useOrgSlug();

  const isOrgScoped = isOrgScopedHome || !!orgSlug;

  const links = isOrgScoped ? orgScopedLinks : megaMenuLinks;

  return (
    <MegaMenuLinksProvider links={links} isEnterprise>
      <div className="rc-ExploreMegaMenuGridItem" css={styles.exploreButtonHeaderSpacing}>
        <SimplifiedMegaMenuWrapper />
      </div>
    </MegaMenuLinksProvider>
  );
};

export default ExploreMegaMenuGridItem;
